import React from 'react';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@fortawesome/pro-regular-svg-icons';

const SPARK_BADGE_STYLE: React.CSSProperties = {
  backgroundColor: 'rgba(var(--bp-primary-rgb), 0.12)',
};

interface Props {
  className?: string;
  onClick?: () => void;
}

export default function SparkBadge({ className, onClick }: Props) {
  return (
    <span
      className={classNames('d-inline-flex align-items-center justify-content-center rounded-2 p-1', className)}
      style={SPARK_BADGE_STYLE}
      onClick={onClick}
    >
      <FontAwesomeIcon className="icon-gradient" icon={faSparkles} />
    </span>
  );
}
